import { Injectable , inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';
import { UtilitySerice } from './utility.service';



@Injectable({
    providedIn: 'root'
})
export class HttpService {
    private apiUrl: string;

    
  _utilityService = inject(UtilitySerice)

    constructor(
        private http: HttpClient,
    ) {
        this.apiUrl = environment.url;
    }
    private getFullUrl(url: string): string {
        const base = this.apiUrl.endsWith('/') ? this.apiUrl.slice(0, -1) : this.apiUrl;
        const path = url.startsWith('/') ? url : '/' + url;
        return base + path;
    }

    get<T>(url: string, httpParams?: any, loader: boolean = true) {
        if (httpParams) {
            for (let item in httpParams) {
                if (httpParams[item] === '' || httpParams[item] === undefined || httpParams[item] === null) {
                    delete httpParams[item];
                }
            }
        }
    
        const options: any = {
            params: httpParams,
            observe: 'body' as const // Ensures only the response body is returned
        };
    
        return this.http.get<T>(this.getFullUrl(url), options);
    }

    post<T>(url : string, data? : any, query? : string, loader = true) {
       
        let trimData = data;
        if (data) {
            if (data instanceof FormData) {
                trimData = data;
            } else {
                trimData = this._utilityService.trim(data);
            }
        }

        return this.http.post<T>(this.getFullUrl(url), trimData);
    }

    patch<T>(url : string, data? : any, loader = true){
        
        let trimData = data;
        if (data) {
            if (data instanceof FormData) {
                trimData = data;
            } else {
                trimData = this._utilityService.trim(data);
            }
        }
        return this.http.patch(this.getFullUrl(url), trimData);
    }

    put<T>(url : string, data? : any, loader = true){
        
        let trimData = data;
        if (data) {
            if (data instanceof FormData) {
                trimData = data;
            } else {
                trimData = this._utilityService.trim(data);
            }
        }
        return this.http.put(this.getFullUrl(url), trimData);
    }

    delete<T>(url: string, loader = true) {
        return this.http.delete<T>(this.getFullUrl(url));
    }
    
    
  

}
